<template>
	<div class="container-fluid">
		<div class="m-2">
      		<div class="alert alert-primary">
        		<div class="h4 text-center">
          			<linkto :link="'/'"/>
          			Új érdeklődő rögzítés
        		</div>
      		</div>
    	</div>
    	<div class="row d-flex justify-content-center">
  		      <div class="col-6 text-center h4">
                Rögzítette: {{$store.getters.user.nev}}
            </div>
            <div class="col-6 text-center h4">
                Rögzítve: {{datum}}
            </div>
  		</div>
    	<div class="row d-flex justify-content-center align-items-center">
  			<inquiring-data
  				:change="false"
  				:inquiring="true"
            	:user="$store.getters.user.nev"
  			>
  			</inquiring-data>
  		</div>
	</div>
</template>
<script type="text/javascript">
import inquiringData from '../customers/customer_data'
export default {
	components: {
		inquiringData
	},

	computed: {
        datum(){
		        return this.$moment().format('YYYY-MM-DD')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/inquiring/create.vue